import { GridApi } from "ag-grid-enterprise";
import { FeatureTypes } from "entity-app/constants";
import { TGoverningSourceTypes } from "entity-app/shared-components/entity-dateblock/models";

export const resetGridFilters = (props: {
  setListFilter: any;
  api: GridApi | undefined;
}) => {
  const { setListFilter, api } = props;
  try {
    const currentFilters: any = api?.getFilterModel();
    const currentFilterCols = Object.keys(currentFilters);
    currentFilterCols.forEach((col: string) => {
      api?.destroyFilter(col);
    });

    setTimeout(() => {
      setListFilter(null);
      api?.onFilterChanged();
    });
  } catch (ex) {
    //
  }
};

export function getFeatureTypeString(id: number): FeatureTypes {
  return Object.keys(FeatureTypes).find(
    (key) => FeatureTypes[key as keyof typeof FeatureTypes] === id
  )! as unknown as FeatureTypes;
}

/**
 * Method to checlk if the given instance id is present in the event log.
 * @param featureInstanceId
 * @param eventLog
 * @param featureId
 * @returns
 */
export function hasTheFeature(
  featureInstanceId: string,
  eventLog: any,
  featureId: string
) {
  let hasFeature = false;
  if (featureId) {
    const objectId = eventLog.object_id;
    const { info } = eventLog;
    hasFeature =
      featureInstanceId === objectId ||
      info?.feature_instance_ids?.includes(featureInstanceId) ||
      info?.linked_features?.some((feature: any) => {
        return feature?.id === featureInstanceId;
      });
  }
  return hasFeature;
}

export const getValueFromDotPath = (obj: any, path: string) => {
  if (!path) return undefined;
  return path.split(".").reduce((acc, part) => acc && acc[part], obj);
};

export const setNestedValue = (obj: any, path: string, value: any) => {
  const keys = path.split(".");
  const lastKey = keys.pop();

  if (lastKey === undefined) return; // Handle empty path safely

  const target = keys.reduce((acc, key) => {
    if (!acc[key]) acc[key] = {};
    return acc[key];
  }, obj);

  target[lastKey] = value;
};

export const getTypeOfGoverningSourceTitle = (
  featureTypeId: number
): TGoverningSourceTypes => {
  let type: TGoverningSourceTypes = "Manually Set Date";
  switch (featureTypeId) {
    case FeatureTypes.ACTIVITIES:
      type = "Linked Activity";
      break;
    case FeatureTypes.PLANNING_ONLY_SUBMITTAL:
      type = "Submittal Plan";
      break;
    default:
      break;
  }
  return type;
};
